import { Order, OrderStatus } from '@/types';

export function defaultValues(order?: Order) {
  return {
    id: order?.id || '',
    orderId: order?.orderId || '',
    quantity: order?.quantity || 0,
    totalPrice: order?.totalPrice || 0,
    status: order?.status || OrderStatus.Requested,
    shippingAddress: order?.shippingAddress || '',
    paymentMethod: order?.paymentMethod || '',
    trackingNumber: order?.trackingNumber || '',
    deliveryDate: order?.deliveryDate || new Date(),
    productId: order?.productId || '',
    product: {
      name: order?.product?.name || '',
      description: order?.product?.description || '',
      price: order?.product?.price || 0,
      category: order?.product?.category || '',
      supplier: order?.product?.supplier || '',
      weight: order?.product?.weight || 0,
      imagePath: order?.product?.imagePath || '',
    },
    clientId: order?.clientId || '',
    createdDate: order?.createdDate || new Date(),
  } as Order;
}
